import { WidgetDefinition, WidgetTextStyle } from './common';
import WidgetType from '../enum/WidgetType';
import Font from '../enum/Font';
import TextAlignment from '../enum/TextAlignment';

const Text: WidgetDefinition = {

    type: WidgetType.TEXT,
    className: 'widget-text',
    contentComponent: 'dmb-widget-content-text',

    settingsSectionComponents: [
        'dmb-section-widget-settings-text',
        'dmb-section-widget-style',
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 0.4,
        height: 0.1
    },

    defaultStyle: {
        opacity: 100
    },

    defaultSettings: (options) => ({
        content: 'Nieuwe tekst',
        textStyle: {
            alignment: TextAlignment.CENTER,
            color: 'FFFFFF',
            font: Font.PRIMARY,
            size: 20,
            bold: false,
            italic: false,
            underlined: false,
            customFont: null,
            lineSpacing: null,
            characterSpacing: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            shadowBlur: null,
            borderColor: null,
            borderSize: null,
            transform: null
        }as WidgetTextStyle
    })
}

export default Text